import React from 'react';

import './Gallery.css';

const Gallery = () => (
  <div>
    
  </div>
);

export default Gallery;
